angular.module('cfn').directive('cfnInputTimeduration', [
  '$rootScope',
  '$log',
  '$timeout',
  function($rootScope, $log, $timeout) {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        class: '@',
        readonly: '=',
        required: '@',
        change: '&'
      },
      replace: true,
      template:
        '<div class="time-duration-custom">' +
        '<input type="text" cfn-enter-tab  ng-model="hh" style="text-align:right" class="hh part {{class}} time-input" ng-readonly="readonly" ng-required="{{required}}" maxlength="2">' +
        '<div tabindex="-1"  class="seperator part" >h</div>' +
        '<input type="text" cfn-enter-tab  ng-model="mm" style="text-align:center" class="mm part {{class}} time-input" ng-readonly="readonly" ng-required="{{required}}"  maxlength="2">' +
        '<div tabindex="-1"  class="seperator part" >m</div>' +
        '<input type="text" cfn-enter-tab  ng-model="ss"  class="ss part {{class}} time-input" ng-readonly="readonly" ng-required="{{required}}"  maxlength="2">' +
        '<div tabindex="-1"  class="seperator part lastpart" >s</div>' +
        '</div>',
      link: function(scope, element, attrs) {
        scope.onChange = function() {
          {
            var hh = parseInt(scope.hh);
            var mm = parseInt(scope.mm);
            var ss = parseInt(scope.ss);
            if (isNaN(hh)) hh = 0;
            if (isNaN(mm)) mm = 0;
            if (isNaN(ss)) ss = 0;

            var val = ss * 1000 + mm * 1000 * 60 + hh * 1000 * 60 * 60;

            scope.model = val;

            // callafter required to have the last change populated
            ang.callAfter(function() {
              scope.change();
            }, scope);
          }
        };
        ang.callAfter(function() {
          $('.hh', element).change(function() {
            ang.apply(scope, function() {
              scope.onChange();
            });
          });
          $('.mm', element).change(function() {
            ang.apply(scope, function() {
              scope.onChange();
            });
          });
          $('.ss', element).change(function() {
            ang.apply(scope, function() {
              scope.onChange();
            });
          });
        }, scope);

        scope.$watch('model', function(newVal, oldVal) {
          if (scope.model != undefined) {
            var val = scope.model;

            var seconds = Math.floor(val / 1000);
            var minutes = Math.floor(seconds / 60);
            seconds -= minutes * 60;
            var hour = Math.floor(minutes / 60);
            minutes -= hour * 60;

            if (!$('.hh', element).is(':focus')) {
              scope.hh = hour;
            }
            if (!$('.mm', element).is(':focus')) {
              if ((minutes + '').length < 2) {
                minutes = '0' + minutes;
              }
              scope.mm = minutes;
            }
            if (!$('.ss', element).is(':focus')) {
              if ((seconds + '').length < 2) {
                seconds = '0' + seconds;
              }
              scope.ss = seconds;
            }
          } else {
          }
        });
      }
    };
  }
]);
